import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";

import '@ant-design/v5-patch-for-react-19';
import { useInitApiAuth } from "./hooks/useInitApiAuth";

export default function App() {
  useInitApiAuth();
  
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
